import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { AnnouncementQuery } from "src/app/services/announcement/announcement.query";
import { AnnouncementService } from "src/app/services/announcement/announcement.service";
import { AnnouncementStore } from "src/app/services/announcement/announcement.store";
import { AnnouncementModel } from "src/app/services/dto/announcement.model";

@Component({
  selector: "app-news-detail",
  templateUrl: "./news-detail.component.html",
  styleUrls: ["./news-detail.component.scss"],
})
export class NewsDetailComponent implements OnInit, OnDestroy {
  annoucmentService = inject(AnnouncementService);
  announcementStore = inject(AnnouncementStore);
  announcementQuery = inject(AnnouncementQuery);
  new: AnnouncementModel;
  progress: number;
  touchPoint: { x: number; y: number } = { x: 0, y: 0 };
  complete = false;
  freeze = false;
  interval: NodeJS.Timeout;
  pageType: "story" | "detail" = "story";

  ngOnInit(): void {
    this.announcementQuery.selectedAnnouncement$.subscribe((o) => {
      this.new = o;
      if (this.new) {
        const announcementList = this.announcementStore.getValue().announcement;
        const index = announcementList.findIndex((x) => x.id === this.new.id);
        this.progress = index;
        if (this.new) {
          this.destroyInterval();
          this.interval = setInterval(() => {
            this.progress += this.freeze ? 0 : 0.01;
            if (Math.floor(this.progress) > index) {
              this.annoucmentService.nextAnnouncement();
            }
          }, 100);
        }
      }
    });
  }

  getProgress(index: number) {
    const floor = Math.floor(this.progress);
    if (floor > index) {
      return 1;
    } else if (floor === index) {
      return this.progress - floor;
    } else {
      return 0;
    }
  }

  trackById(item: AnnouncementModel): string {
    return item.id;
  }

  ngOnDestroy(): void {
    this.destroyInterval();
  }

  destroyInterval() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  touchStart(event: TouchEvent | MouseEvent) {
    if ("changedTouches" in event) {
      this.touchPoint = {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY,
      };
    } else {
      this.touchPoint = {
        x: event.pageX,
        y: event.pageY,
      };
    }

    this.complete = false;
    setTimeout(() => {
      if (!this.complete) {
        this.freeze = true;
      }
    }, 1000);
  }

  touchEnd(event: TouchEvent | MouseEvent) {
    if(event.srcElement && (event.srcElement as HTMLElement).classList.contains('close-btn')){
      this.annoucmentService.closeAnnouncement();
      this.unFreeze();
      return;
    }

    const deltaX =
      this.touchPoint.x -
      ("changedTouches" in event
        ? event.changedTouches[0].clientX
        : event.pageX);
    const deltaY =
      this.touchPoint.y -
      ("changedTouches" in event
        ? event.changedTouches[0].clientY
        : event.pageY);
    if (!this.freeze) {
      if (deltaX < 100 && deltaX > -100 && deltaY > -100) {
        this.freeze = true;
        this.complete = true;
        this.pageType = "detail";
      } else {
        if (deltaX > 100) {
          this.annoucmentService.nextAnnouncement();
          this.unFreeze();
        } else if (deltaX < -100) {
          this.annoucmentService.prevAnnouncement();
          this.unFreeze();
        } else if (deltaY < -100) {
          this.annoucmentService.closeAnnouncement();
          this.unFreeze();
        }
      }
    } else {
      this.unFreeze();
    }
  }

  unFreeze() {
    this.complete = true;
    this.freeze = false;
  }

  detailToStory() {
    this.pageType = "story";
    this.unFreeze();
  }
}
